import { Injectable, ElementRef, NgZone, OnInit } from '@angular/core';
import { Address } from '../Models/Address';
import { GooglePlace } from '../Models/GooglePlace';

@Injectable()
export class PlacesService implements OnInit {

  storedAddress : Address;
  userSettings = {
    inputPlaceholderText: "", 
    showSearchButton: false,
    showCurrentLocation:false,
    showRecentSearch: false,
  };

  constructor() 
  {
  }
    
  ngOnInit(): void {
    
  }

  

  public DumpParts(placeResult : object[]) : void {
    let p = this.ConvertParts(placeResult)
    console.log(p);
  }

  CreateFullAddress(placeResult : object[]) : Address {
    let addy = new Address();
    let gParts = this.ConvertParts(placeResult);
    try {
      //we only ask for the street address on the lookup question
      addy.StreetAddress = gParts.filter(e => e.types[0] == "street_number")[0].short_name + " " + gParts.filter(e => e.types[0] == "route")[0].short_name;
      addy.Zip = gParts.filter(e => e.types[0] == "postal_code")[0].short_name;
    } catch (error) { }
    //these will always be populated regardless of the type of location question
    addy.City = gParts.filter(e => e.types[0] == "locality")[0].short_name;
    addy.State = gParts.filter(e => e.types[0] == "administrative_area_level_1")[0].short_name;
    addy.County = gParts.filter(e => e.types[0] == "administrative_area_level_2")[0].short_name || gParts.filter(e => e.types[0] == "administrative_area_level_2")[0].short_name;
    return addy;
  }
  
  autoCompleteCallback(selectedData : any, debug : boolean) : void {
    if(selectedData.response) {
      if(debug) console.log(selectedData.data.address_components);
      try {
        this.storedAddress = this.CreateFullAddress(selectedData.data.address_components);
        if(debug) console.log(this.storedAddress);
      } catch (error) {
        console.log(error);
      }      
    }
  }
  
  private ConvertParts(placeResult : object[]) : GooglePlace[] {
    let places : GooglePlace[] = new Array<GooglePlace>();
    placeResult.forEach(e => {
      places.push(<GooglePlace>e)
    });
    return places;
  }

}




// WEBPACK FOOTER //
// C:/git/SynergiPartners 7-Eleven Screening/src/app/services/places.service.ts